export const questionPropertyMapper = {
  ง่าย: 'examPreview.questionPropertyMapper.easy',
  กลาง: 'examPreview.questionPropertyMapper.medium',
  ยาก: 'examPreview.questionPropertyMapper.hard',
  คำนวณ: 'examPreview.questionPropertyMapper.calculated',
  ไม่คำนวณ: 'examPreview.questionPropertyMapper.notCalculated',
};
